<template lang="pug">
.size.data.left(:class="{'new-item': isNew}")
  .data-general-information(@click="expand = !expand")
    .item-list
      .data-number-list(:class="{hidden: isNew}") {{ isNew ? 0 : index + 1 }}
      .data-information-list
        .data-title-list {{ data.size }}
        .data-description-list.capitalize(v-if="!history") {{ data.spanish }}
        .data-description-list.capitalize(v-else :class="colorTransaction(data.transaction)") {{ data.transaction }}d
          span.lowercase  - {{ dateTime(data.createdAt) }}

  transition.user-details-information(name="slide-fade")
    shForm.list(v-if="expand && !history" :dataOriginal="data" :fillData="true")

  transition.user-details-information(name="slide-fade")
    shHistory(v-if="expand && history" :dataOriginal="data" :color="colorTransaction(data.transaction)")

  //.check-list(v-model="checked")
    .input-container-checkbox
      label.label-checkbox-list(:for="`Check${index}`")
        input.input-checkbox-list(:id="`Check${index}`" type="checkbox")
        .checkmark
</template>

<script>
import shForm from './Form'
import shHistory from './History'
import shExpandButton from '@/components/elements/ExpandButton'
import mFilters from '@/mixins/filters'
import mForm from '@/mixins/form'

export default {
  name: 'Size',

  mixins: [mFilters, mForm],

  components: { shForm, shExpandButton, shHistory },

  props: {
    data: Object,
    index: Number,
    isNew: Boolean,
    history: Boolean
  },

  data () {
    return {
      checked: false,
      expand: false
    }
  },

  beforeDestroy () {
    this.expand = false
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/size/Size.vue